<template>
	<div class="other_phone">
		<div class="back_nav">
			<a href="javascript:void(0);" class="back" @click="$parent.otherPhoneInfoSet(false)"><img class="img" src="./images/back.png" /></a>
			<p class="p">其它手机</p>
		</div>
		<Scrapper class="examples">
			<div class="container">
				<div @click="choose('三星手机安装说明')"><img src='./images/other_GalaxyS20Ultra5G.png'></div>
				<div @click="choose('其他手机安装说明')"><img src='./images/other_other.png'></div>
			</div>
		</Scrapper>
	</div>
</template>
<script>
import Scrapper from '@/libaray/component/Scrapper'
export default {
	data() {
		return {}
	},
	components: { Scrapper },
	computed: {},
	watch: {},
	methods: {
		choose(params) {
			this.$emit("choose", params)
		},
	},
	created() { },
	mounted() {
	}
}
</script>
<style lang="scss" scoped>
.other_phone {
	position: absolute;
	background: #fff;
	z-index: 99;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	flex-direction: column;
	.back_nav {
		width: 100%;
		height: 50px;
		position: relative;
		display: flex;
		align-items: center;
		flex: 0 0 auto;
		border-bottom: 1px solid #d8d8d8;

		.back {
			// height: 100%;
			position: relative;
			z-index: 5;
			display: flex;
			align-items: center;
			padding: 0 15px;

			.img {
				height: 20px;
				width: auto;
			}
		}

		.p {
			font-size: 17px;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			// height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.examples {
		flex: 1 1 0;
		overflow: hidden;

		.container {
			padding-bottom: 40px;
			padding-top: 12px;
			display: flex;
			flex-direction: column;
			align-items: center;
			> div {
				width: calc(702px/2);
				> img {
					width: 100%;
				}
			}
			> div:not(:first-child) {
				margin-top: 8px;
			}
		}
	}
}
.other_phone_max {
	.back_nav {
		height: 50px * 2;
		border-bottom: 1px * 2 solid #d8d8d8;

		.back {
			padding: 0 15px * 2;

			.img {
				height: 20px * 2;
			}
		}

		.p {
			font-size: 17px * 2;
		}
	}
	.examples {
		.container {
			padding-bottom: 40px * 2;
			padding-top: 12px * 2;
			> div {
				width: 702px;
			}
			> div:not(:first-child) {
				margin-top: 8px * 2;
			}
		}
	}
}
.slide-enter-active {
	transition: 0.1s all ease-out;
	transform: translateX(100%);
}
.slide-enter-to {
	transform: translateX(0%);
}
.slide-leave-active {
	transition: 0.1s all ease-out;
	transform: translateX(0%);
}
.slide-leave-to {
	transform: translateX(100%);
}
</style>